import { LoaderService } from './../../services/loader.service';
import { DictToJSON } from './../../model/dictionary.model';
import { Store, select } from '@ngrx/store';
import { Polygon } from '../../model/polygon.model';
import { MsgSeverities } from './../../services/message.service';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { MiddlewareService } from 'src/app/services/middleware.service';
import { Dictionary } from 'src/app/model/dictionary.model';
import { MsgService } from 'src/app/services/message.service';
import { FloorPlan } from 'src/app/model/floorplan.model';
import { calcArea, polygonColors } from 'src/app/shared/utils';
import * as SVGFAIconsSolid from '@fortawesome/free-solid-svg-icons';
import * as SVGFAIconsRegular from '@fortawesome/free-regular-svg-icons';
import { AppState } from 'src/app/app.state';
import * as FloorPlanActions from '../../store/actions/floorplan.actions';
import { ConfirmModalComponent } from 'src/app/shared/confirm-modal/confirm-modal.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-right-panel',
  templateUrl: './right-panel.component.html',
  styleUrls: ['./right-panel.component.scss']
})
export class RightPanelComponent implements OnInit, OnDestroy {

  @ViewChild('dm') tableMisurazioni: any;
  @ViewChild('dr') tableDizionario: any;

  @Input() imageChanged: Subject<string> = new Subject();
  @Input() onDeleteElements: Subject<string[]> = new Subject();
  @Input() onPolygonSelection: Subject<string> = new Subject();
  @Input() onDrawPolygon: Subject<[number, number][]> = new Subject();
  @Input() onResizePolygon: Subject<[number, number][]> = new Subject();
  @Input() onDrawRect: Subject<[number, number][]> = new Subject();
  @Input() undoDelete: Subject<string[]> = new Subject();
  @Input() undoCreate: Subject<string[]> = new Subject();
  @Input() undoResizeMove: Subject<string[]> = new Subject();
  @Input() undoAssignDict: Subject<string[]> = new Subject();
  @Input() redoCreate: Subject<string[]> = new Subject();
  @Input() redoResizeMove: Subject<string[]> = new Subject();
  @Input() redo: Subject<string[]> = new Subject();
  @Input() redoAssignDict: Subject<string[]> = new Subject();
  @Input() changeScale: Subject<number> = new Subject();
  @Input() savePlan: Subject<boolean> = new Subject();
  @Input() sendPlan: Subject<boolean> = new Subject();
  @Input() updatePrintData: Subject<boolean> = new Subject();

  @Output() onRowSelection: EventEmitter<{polygon: Polygon, selected: boolean}> = new EventEmitter();

  get solidIcons() {
    return SVGFAIconsSolid;
  }

  get regularIcons() {
    return SVGFAIconsRegular;
  }

  dmColumns = [
    {field: 'normalized', header: 'Norm.', width: '31%'},
    {field: 'rooms', header: 'Rooms', width: '31%'},
    // {field: 'macro', header: 'Macro', width: '20%'},
    // {field: 'tari_coeff', header: 'Coeff'},
    {field: 'area', header: 'Sup', width: '18%'},
    {field: 'alerts', header: 'Alert', width: '20%'}
  ]

  drColumns = [
    {field: 'destinazioneNormalizzata', header: 'Norm.', width: '29%'},
    {field: 'destinazionePlanimetria', header: 'Rooms', width: '26%'},
    {field: 'macrogruppo', header: 'Macro', width: '20%'},
    {field: 'coefficienteCalcoloSupTari', header: 'K', width: '10%'},
    {field: 'checked', header: '', width: '15%'},
  ]

  methodDraw: any;
  undoManager: any;
  testataJson: any;
  scrollHeight: string = '120px';
  workSaved: boolean = false;
  planSent: boolean = false;
  sendFloorPlan: boolean = false;
  currentScale: number;
  tableDataMisu: Polygon[] = [];
  tableDataMisuOrig: Polygon[] = [];
  newRooms: Polygon[] = [];
  tableDataDict: Dictionary[] = [];
  subscriptions: Subscription[] = [];
  totSuperficie: string;
  totSuperficieTaRI: string;
  insertMode: boolean = false;
  jsonLoaded: boolean = false;
  dictLoaded: boolean = false;
  selectedRow: Polygon = new Polygon();
  selectedDict: Dictionary;
  drawingDict: Dictionary;
  isSelectionFromTable: boolean = false;
  newDict: Dictionary = new Dictionary();

  dictStatus: any = {};
  disableSave: boolean = false;
  showHidePoly: boolean = true;

  constructor(
    private service: MiddlewareService,
    private msgService: MsgService,
    private store: Store<AppState>,
    private dialogService: DialogService,
    private loader: LoaderService
  ) { }

  ngOnInit() {
    this.methodDraw = window['methodDraw'];
    this.undoManager = this.methodDraw.canvas.undoMgr;
    const canmod = localStorage.getItem('canmod');
    this.disableSave = canmod === 'N' ? true : canmod === 'S' ? false : true;

    this.subscriptions.push(
      this.service.getDictionary().subscribe((dict: JSON[]) => {
        dict.forEach((val: JSON, idx: number) => {
          val['id'] = idx;
          this.tableDataDict.push({
            id: idx,
            destinazionePlanimetria: val[DictToJSON.destinazionePlanimetria],
            destinazioneNormalizzata: val[DictToJSON.destinazioneNormalizzata],
            macrogruppo: val[DictToJSON.macrogruppo],
            coefficienteCalcoloSupTari: val[DictToJSON.coefficienteCalcoloSupTari]
          });
        });
        this.dictLoaded = true;
      })
    );

    this.subscriptions.push(
      this.imageChanged.subscribe(val => {
        if (val) {
          this.jsonLoaded = false;
        }
      })
    )

    this.subscriptions.push(
      this.store.select('floorPlan').subscribe((plan: FloorPlan) => {
        if (plan && plan.testata) {
          this.testataJson = Object.assign({}, plan.testata);
          this.currentScale = plan.testata.scala;
          this.tableDataMisu = [];
          this.tableDataMisuOrig = [];
          if (plan.poligono && plan.poligono.length > 0) {
            plan.poligono.forEach((val: Polygon) => {
              let roomsExt = '';
              if (val.rooms) {
                roomsExt = val.rooms.find(val => typeof val === 'string' && val.indexOf('external') !== -1);
              }
              if (!roomsExt) {
                this.tableDataMisu.push(Object.assign({}, val));
                this.tableDataMisuOrig.push(Object.assign({}, val));
              }
            });
            this.sortTableDataMisu();
          }
          this.showHidePoly = true;
          this.calcTotSup();
          setTimeout(() => {this.jsonLoaded = true;
            const workareaHeight = document.getElementById('workarea').offsetHeight;
            if (workareaHeight > 0) {
              this.scrollHeight = (workareaHeight/100) * 20.7 + 'px';
            }
            if (this.workSaved) {
              this.workSaved = false;
              this.loader.hide();
              this.msgService.showMsg(MsgSeverities.SUCCESS, 'Info', 'Salvataggio effettuato correttamente');
            }
            if (this.planSent) {
              this.loader.hide();
              this.planSent = false;
              this.undoManager.resetUndoStack();
            }
          }, 250);
        }
      })
    );

    this.subscriptions.push(
      this.onDeleteElements.subscribe(val => {
        if (val && val.length > 0) {
          this.tableDataMisu = this.tableDataMisu.filter(elem => val.indexOf(elem.id) === -1);
        }
      })
    )

    this.subscriptions.push(
      this.onPolygonSelection.subscribe(val => {
        if (val) {
          this.selectedRow = this.tableDataMisu.find(item => item.id === val);
          this.selectTableRow();
        } else {
          this.selectedRow = undefined;
        }
        this.autoSelectDict();
      })
    );

    this.subscriptions.push(
      this.onDrawPolygon.subscribe((points: [number, number][]) => {
        if (points) {
          this.createNewRoom(points, 'currPolygon');
        }
      })
    );

    this.subscriptions.push(
      this.onResizePolygon.subscribe((points: [number, number][]) => {
        if (points) {
          const elem = document.getElementById('resizePolygon');
          if (elem) {
            const id = elem.getAttribute('value');
            this.tableDataMisu.forEach(val => {
              if (val.id === id) {
                val.contour = points;
                val.area = calcArea(points, this.currentScale);
              }
            });
            this.calcTotSup();
          }
        }
      })
    );

    this.subscriptions.push(
      this.onDrawRect.subscribe((points: [number, number][]) => {
        if (points) {
          this.createNewRoom(points, 'currRect');
        }
      })
    );

    this.subscriptions.push(
      this.undoDelete.subscribe(val => {
        if (val && val.length > 0) {
          val.forEach(id => {
            const origElem = this.tableDataMisuOrig.find(elem => elem.id === id);
            this.tableDataMisu.push(origElem);
            this.selectedRow = origElem;
          });
          this.calcTotSup();
          this.sortTableDataMisu();
          this.selectTableRow();
        }
      })
    );

    this.subscriptions.push(
      this.undoCreate.subscribe(val => {
        if (val && val[0]) {
          this.tableDataMisu = this.tableDataMisu.filter(elem => elem.id !== val[0]);
          this.sortTableDataMisu();
          this.calcTotSup();
        }
      })
    );

    this.subscriptions.push(
      this.undoResizeMove.subscribe(val => {
        if (val && val[0]) {
          const points = [];
          const cmd = this.undoManager.undoStack[this.undoManager.undoStackPointer - 1]; 
          let prevVals;
          if (cmd === 'Change path Move path point(s)') {
            prevVals = this.undoManager.undoStack[this.undoManager.getUndoStackSize() - 1].oldValues;
          } else {
            if (this.checkUndoStack()) {
              prevVals = this.undoManager.undoStack[this.undoManager.getUndoStackSize() - 1].stack[0].stack[0].oldValues;
            } else {
              return;
            }
          }
          this.methodDraw.canvas.addSvgElementFromJson({
            "element": "path",
            "attr": {
              "d": prevVals.d,
              "id": 'tmp_undo',
              "fill-opacity": 0.25,
              "stroke-width": 2.5,
              "style": "pointer-events: all"
            }
          });
          const elem = this.methodDraw.canvas.getElem('tmp_undo');
          for (let i = 0; i < elem.pathSegList.numberOfItems - 1; i++) {
            points.push([elem.pathSegList.getItem(i).x, elem.pathSegList.getItem(i).y]);
          }
          this.methodDraw.canvas.getElem('tmp_undo').remove();
          this.tableDataMisu.forEach(elem => {
            if (elem.id === val[0]) {
              elem.contour = points;
              elem.area = calcArea(points, this.currentScale);
            }
          })
          this.calcTotSup();
        }
      })
    );

    this.subscriptions.push(
      this.undoAssignDict.subscribe(val => {
        if (val && val[0]) {
          const elem = this.tableDataMisu.find(item => item.id === val[0]);
          elem.rooms = undefined;
          elem.normalized = undefined;
          elem.macro = undefined;
          elem.tari_coeff = undefined;
        }
      })
    )

    this.subscriptions.push(
      this.redoCreate.subscribe(val => {
        if (val && val[0]) {
          val.forEach(id => {
            const origElem = this.newRooms.find(elem => elem.id === id);
            this.tableDataMisu.push(origElem);
            this.selectedRow = origElem;
          });
          this.calcTotSup();
          this.sortTableDataMisu();
          this.selectTableRow();
        }
      })
    );

    this.subscriptions.push(
      this.redoResizeMove.subscribe(val => {
        if (val && val[0]) {
          let cmd;
          const points = [];
          if (this.undoManager.undoStackPointer < this.undoManager.undoStack.length && this.undoManager.undoStack.length > 0) {
            cmd = this.undoManager.undoStack[this.undoManager.undoStackPointer]; 
          } else {
            return;
          }
          let newVals;
          if (cmd === 'Change path Move path point(s)') {
            newVals = this.undoManager.undoStack[this.undoManager.getRedoStackSize()].newValues;
          } else {
            if (this.checkRedoStack()) {
              newVals = this.undoManager.undoStack[this.undoManager.getRedoStackSize()].stack[0].stack[0].newValues; 
            } else {
              return;
            }
          }
          this.methodDraw.canvas.addSvgElementFromJson({
            "element": "path",
            "attr": {
              "d": newVals.d,
              "id": 'tmp_redo',
              "fill-opacity": 0.25,
              "stroke-width": 2.5,
              "style": "pointer-events: all"
            }
          });
          const elem = this.methodDraw.canvas.getElem('tmp_redo');
          for (let i = 0; i < elem.pathSegList.numberOfItems - 1; i++) {
            points.push([elem.pathSegList.getItem(i).x, elem.pathSegList.getItem(i).y]);
          }
          this.methodDraw.canvas.getElem('tmp_redo').remove();
          this.tableDataMisu.forEach(elem => {
            if (elem.id === val[0]) {
              elem.contour = points;
              elem.area = calcArea(points, this.currentScale);
            }
          })
          this.calcTotSup();
        }
      })
    )

    this.subscriptions.push(
      this.redoAssignDict.subscribe(val => {
        if (val && val[0]) {
          const elem = this.tableDataMisu.find(item => item.id === val[0]);
          const lastDict = this.dictStatus[elem.id].dict;
          elem.rooms = [lastDict.destinazionePlanimetria];
          elem.normalized = [lastDict.destinazioneNormalizzata];
          elem.macro = [lastDict.macrogruppo];
          elem.tari_coeff = [lastDict.coefficienteCalcoloSupTari];
          this.methodDraw.canvas.setColor('fill', this.dictStatus[elem.id].color, false);
          this.methodDraw.canvas.setColor('stroke', this.dictStatus[elem.id].color, false);
        }
      })
    )

    this.subscriptions.push(
      this.changeScale.subscribe(val => {
        this.tableDataMisu.forEach(item => {
          item.area = calcArea(item.contour, val);
        });
        this.currentScale = val;
        this.calcTotSup();
      })
    );

    this.subscriptions.push(
      this.savePlan.subscribe(val => {
        if (val) {
          this.loader.show();
          const newPlan: FloorPlan = new FloorPlan();
          newPlan.testata = this.testataJson;
          newPlan.poligono = this.tableDataMisu;
          this.workSaved = true;
          this.store.dispatch(new FloorPlanActions.SetFloorplan(newPlan));
        }
      })
    );

    this.subscriptions.push(
      this.sendPlan.subscribe(val => {
        if (val) {
          const newPlan: FloorPlan = new FloorPlan();
          newPlan.testata = this.testataJson;
          newPlan.poligono = this.tableDataMisu;
          let rooms_ok: number = 0;
          let rooms_blank: number = 0;
          let rooms_unk: number = 0;
          newPlan.poligono.forEach(val => {
              if (val.rooms && val.rooms[0]) {
                  if (val.normalized && val.normalized[0]) {
                      rooms_ok++;
                  } else if (!val.normalized || (val.normalized && !val.normalized[0])) {
                      rooms_unk++;
                  }
              } else if (!val.rooms || (val.rooms && !val.rooms[0])) {
                  rooms_blank++;
              }
          });
          newPlan.testata.rooms_ok = rooms_ok;
          newPlan.testata.rooms_blank = rooms_blank;
          newPlan.testata.rooms_unk = rooms_unk;
          newPlan.testata.error = '';
          let checkPlan = true;
          for(let i = 0; i < newPlan.poligono.length; i++) {
            const elem = newPlan.poligono[i];
            if (!elem.normalized || (elem.normalized && !elem.normalized[0])) {
              checkPlan = false;
              break;
            }
          }
          if (!checkPlan) {
            const ref = this.dialogService.open(ConfirmModalComponent, {
              header: 'Attenzione!',
              width: '20%',
              closable: false,
              data: {
                confirmLabel: 'Procedi',
                rejectLabel: 'Annulla',
                message: 'La planimetria presenta elementi non normalizzati. Procedere comunque con l\'invio?'
              }
            });
            ref.onClose.subscribe(val => {
              if (val) {
                this.loader.show();
                this.planSent = true;
                this.store.dispatch(new FloorPlanActions.SendFloorplan(newPlan));
              }
            });
          } else {
            this.loader.show();
            this.planSent = true;
            this.store.dispatch(new FloorPlanActions.SendFloorplan(newPlan));
          }
        }
      })
    );

    this.subscriptions.push(
      this.updatePrintData.subscribe(val => {
        if (val) {
          const newPlan: FloorPlan = new FloorPlan();
          newPlan.testata = this.testataJson;
          newPlan.poligono = this.tableDataMisu;
          this.store.dispatch(new FloorPlanActions.SetFloorplan(newPlan));
        }
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }

  sortTableDataMisu() {
    this.tableDataMisu.sort((a, b) => {
      if (!a.normalized || (a.normalized && !a.normalized[0])) {
        return -1;
      }
      if (!b.normalized || (b.normalized && !b.normalized[0])) {
        return 1;
      }
      return (a.normalized[0].toUpperCase() > b.normalized[0].toUpperCase()) ? 1 : -1;
    });
  }

  checkUndoStack() {
    return this.undoManager.undoStack[this.undoManager.getUndoStackSize() - 1] &&
      this.undoManager.undoStack[this.undoManager.getUndoStackSize() - 1].stack && 
      this.undoManager.undoStack[this.undoManager.getUndoStackSize() - 1].stack[0] && 
      this.undoManager.undoStack[this.undoManager.getUndoStackSize() - 1].stack[0].stack && 
      this.undoManager.undoStack[this.undoManager.getUndoStackSize() - 1].stack[0].stack[0];
  }

  checkRedoStack() {
    return this.undoManager.undoStack[this.undoManager.getRedoStackSize()] &&
      this.undoManager.undoStack[this.undoManager.getRedoStackSize()].stack && 
      this.undoManager.undoStack[this.undoManager.getRedoStackSize()].stack[0] && 
      this.undoManager.undoStack[this.undoManager.getRedoStackSize()].stack[0].stack && 
      this.undoManager.undoStack[this.undoManager.getRedoStackSize()].stack[0].stack[0];
  }

  createNewRoom(points: [number, number][], elemId: string) {
    const newRoom = new Polygon();
    const element = document.getElementById(elemId);
    let lastRowIdx = 0;
    this.tableDataMisu.forEach(val => {
      const curId = parseInt(val.id.split('_')[1]);
      if (curId > lastRowIdx) {
        lastRowIdx = curId;
      }
    })

    newRoom.contour = points;
    newRoom.area = calcArea(points, this.currentScale);
    newRoom.id = 'polygon_' + (lastRowIdx + 1);
    if (element) {
      element.id = newRoom.id;
    }

    if (this.drawingDict) {
      newRoom.rooms = [this.drawingDict.destinazionePlanimetria];
      newRoom.normalized = [this.drawingDict.destinazioneNormalizzata];
      newRoom.macro = [this.drawingDict.macrogruppo];
      newRoom.tari_coeff = [this.drawingDict.coefficienteCalcoloSupTari];
      this.methodDraw.canvas.clearSelection();
      this.methodDraw.canvas.addToSelection([element]);
      this.methodDraw.canvas.setColor('fill', polygonColors.green, false);
      this.methodDraw.canvas.setColor('stroke', polygonColors.green, false);
      this.selectedDict = this.drawingDict;
    }

    newRoom.alerts = [];

    if (elemId === 'currRect')  {
      setTimeout(() => {
        this.undoManager.undoStack.forEach(val => {
          if (val && val.text === 'Create rect') {
            val.text = 'Create path';
            val.elem = element;
            console.log(val);
          }
        });
      }, 100)
    }

    if (elemId === 'currPolygon') {
      setTimeout(() => {
        this.undoManager.undoStack.forEach(val => {
          if (val && val.text === 'Create path' && val.elem.id === 'currPolygon') {
            val.elem = element;
            console.log(val);
          }
        });
      }, 100)
    }

    this.tableDataMisu.push(newRoom);
    this.newRooms.push(newRoom);
    const tableDom = this.tableMisurazioni.el.nativeElement.getElementsByClassName('ui-table-scrollable-body')[0];
    tableDom.scrollTo(0, tableDom.clientHeight);
    this.calcTotSup();
  }

  calcTotSup() {
    let sumReale = 0;
    let sumTaRI = 0;
    this.tableDataMisu.forEach((misu: Polygon) => {
      if (misu.normalized && 
          misu.normalized.length > 0 && 
          misu.tari_coeff && 
          misu.tari_coeff[0] !== undefined) {
        sumTaRI += misu.area * misu.tari_coeff[0];
      }
      sumReale += misu.area;
    });
    this.totSuperficie = sumReale.toFixed(0);
    this.totSuperficieTaRI = sumTaRI.toFixed(0);
  }

  selectTableRow() {
    if (this.selectedRow) {
      const tableDom = this.tableMisurazioni.el.nativeElement.getElementsByClassName('ui-table-scrollable-body')[0];
      const rowIndex = this.tableDataMisu.indexOf(this.selectedRow);
      const rowDoms = tableDom.children[0].children[1].children;
      let scrollToSize = 0;
      if (rowIndex <= rowDoms.length) {
        for (let i = 0; i < rowIndex; i++) {
          const row = rowDoms[i];
          scrollToSize += row.clientHeight;
        }
        if (!this.isSelectionFromTable) {
          tableDom.scrollTop = scrollToSize;
        }
        this.isSelectionFromTable = false;
      }
    }
  }

  onNewDict() {
    this.insertMode = true;
  }

  onCancelInsertMode() {
    this.insertMode = false;
  }

  insertNewDict() {
    const ref = this.dialogService.open(ConfirmModalComponent, {
      header: 'Attenzione!',
      width: '20%',
      closable: false,
      data: {
        confirmLabel: 'Ok',
        rejectLabel: 'Annulla',
        message: 'Si è sicuri di voler inserire il nuovo elemento nel dizionario?'
      }
    });
    ref.onClose.subscribe(val => {
      if (val) {
        this.tableDataDict.push(this.newDict);
        this.service.putDictionary(this.tableDataDict).subscribe(val => {
          this.msgService.showMsg(MsgSeverities.SUCCESS, 'Info', 'Nuovo elemnto del dizionario inserito correttamente');
          this.insertMode = false;
          this.newDict = new Dictionary();
        });
      }
    });
  }

  onAssignDict(dict: Dictionary) {
    if (!this.selectedRow || (this.selectedRow && !this.selectedRow.id)) {
      this.msgService.showMsg(
        MsgSeverities.WARNING,
        'Attenzione',
        'Selezionare un elemento della planimetria!',
        false,
      )
    } else {
      const selElems = this.methodDraw.canvas.getSelectedElems();
      if (selElems.length > 1) {
        selElems.forEach(elem => {
          const tableElem = this.tableDataMisu.find(item => item.id === elem.id);
          if (tableElem) {
            this.dictToRow(tableElem, dict);
          }
        })
      } else if (selElems.length === 1) {
        this.dictToRow(this.selectedRow, dict);
      }
      this.calcTotSup();
    }
  }

  dictToRow(row: Polygon, dict: Dictionary) {
    row.rooms = [dict.destinazionePlanimetria];
    row.normalized = [dict.destinazioneNormalizzata];
    row.macro = [dict.macrogruppo];
    row.tari_coeff = [dict.coefficienteCalcoloSupTari];

    let color = '';
    const roomsExt = row.rooms.find(val => typeof val === 'string' && val.indexOf('external') !== -1);
    if (row.normalized && row.normalized.length > 0) {
      color = polygonColors.green;
    } else {
      if (roomsExt) {
        color = polygonColors.yellow;
      } else {
        color = polygonColors.blue;
      }
    }
    this.dictStatus[row.id] = {color: color, dict: dict};
    this.methodDraw.canvas.setColor('fill', color, false);
    this.methodDraw.canvas.setColor('stroke', color, false);
  }

  onTableRowSelection(evt, selected) {
    const row: Polygon = evt.data;
    if (selected) {
      this.selectedRow = row;
      this.autoSelectDict();
    } else {
      this.selectedRow = new Polygon();
      this.selectedDict = new Dictionary();
    }
    this.onRowSelection.emit({polygon: row, selected: selected});
    this.isSelectionFromTable = true;
  }

  onDictRowSelection(evt, selected) {
    if (selected) {
      this.drawingDict = evt.data
    } else {
      this.drawingDict = new Dictionary();
    }
  }

  autoSelectDict() {
    let dictFound = false;
    const tableDom = this.tableDizionario.el.nativeElement.getElementsByClassName('ui-table-scrollable-body')[0];
    this.tableDataDict.forEach(dict => {
      const check = this.selectedRow &&
      this.selectedRow.normalized && this.selectedRow.tari_coeff && this.selectedRow.macro && (
          dict.destinazioneNormalizzata === this.selectedRow.normalized[0] &&
          dict.coefficienteCalcoloSupTari === this.selectedRow.tari_coeff[0] &&
          dict.macrogruppo === this.selectedRow.macro[0]
        )
      if (check && !dictFound) {
        dictFound = true;
        this.selectedDict = dict;
        const rowIndex = this.tableDataDict.indexOf(this.selectedDict);
        const rowDoms = tableDom.children[0].children[1].children;
        let scrollToSize = 0;
        if (rowIndex <= rowDoms.length) {
          for (let i = 0; i < rowIndex; i++) {
            const row = rowDoms[i];
            const isEdge = navigator.userAgent.indexOf('Edge') !== -1;
            if (row) {
              scrollToSize += isEdge ? row.clientHeight - 0.6 : row.clientHeight;
            }
          }
          tableDom.scrollTop = scrollToSize;
        }
      }
    });
    if (!dictFound) {
      this.selectedDict = new Dictionary();
      tableDom.scrollTop = 0;
    }
  }

  showHidePolygons(evt) {
    this.methodDraw.canvas.clearSelection();
    if (evt) {
      this.tableDataMisu.forEach(item => {
        document.getElementById(item.id).removeAttribute('display');
      });
    } else {
      this.tableDataMisu.forEach(item => {
        document.getElementById(item.id).setAttribute('display', 'none');
      });
    }
  }

}
